import { type LegendStripText, legendHeight } from '@better-lights/core';

/** Font for legend strips burned into exports (docs/spec/03 §7.2: Inter SemiBold 600). */
export const LEGEND_FONT = 'Inter';

export async function legendFontReady(): Promise<boolean> {
  try {
    await document.fonts.load(`600 16px ${LEGEND_FONT}`);
    return document.fonts.check(`600 16px ${LEGEND_FONT}`);
  } catch {
    return false;
  }
}

/** Draws the legend strip below the photo (`top` = H). Text widths are advance widths. */
export function drawLegendStrip(
  ctx: OffscreenCanvasRenderingContext2D | CanvasRenderingContext2D,
  W: number,
  top: number,
  strip: LegendStripText,
): void {
  const unit = Math.max(14, W * 0.016);
  const h = legendHeight({ width: W }, strip.rows.length);
  ctx.fillStyle = '#0E1014';
  ctx.fillRect(0, top, W, h);
  const pad = unit * 1.2;
  const font = (px: number) => `600 ${px}px ${LEGEND_FONT}, sans-serif`;
  ctx.textBaseline = 'alphabetic';
  ctx.textAlign = 'left';
  ctx.fillStyle = '#F2F0EB';
  ctx.font = font(unit * 1.05);
  ctx.fillText(strip.title, pad, top + unit * 1.9);
  strip.rows.forEach((row, i) => {
    const y = top + unit * (3.6 + i * 1.9);
    ctx.fillStyle = row.color;
    ctx.beginPath();
    ctx.roundRect(pad, y - 0.55 * unit, 1.8 * unit, 0.5 * unit, 0.25 * unit);
    ctx.fill();
    ctx.fillStyle = '#F2F0EB';
    ctx.font = font(unit * 0.9);
    ctx.fillText(row.label, pad + 2.5 * unit, y);
    ctx.fillStyle = '#9AA1AC';
    ctx.font = font(unit * 0.78);
    ctx.fillText(row.right, W - pad - ctx.measureText(row.right).width, y);
  });
  if (strip.total) {
    ctx.fillStyle = '#F2F0EB';
    ctx.font = font(unit * 0.9);
    ctx.fillText(strip.total, W - pad - ctx.measureText(strip.total).width, top + unit * 1.9);
  }
}
